import React from 'react';
import { Link } from 'react-router-dom';

const AcessoNegado = () => {
  return (
    <>
      <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl w-full bg-gray-800 p-8 rounded-xl shadow-lg text-center text-white">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-red-100 p-4">
              <svg 
                className="h-12 w-12 text-red-600" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
                aria-hidden="true"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
                />
              </svg>
            </div>
          </div>
          
          <h1 className="text-4xl font-extrabold text-red-600 mb-4">
            Acesso Negado
          </h1>
          
          <h2 className="text-xl font-medium text-gray-200 mb-6">
            Você não tem permissão para acessar esta página.
          </h2>
          
          <p className="text-gray-300 mb-8 max-w-lg mx-auto">
            Verifique suas credenciais ou entre em contato com o administrador do sistema 
            para obter acesso a este recurso.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
              Voltar para a Página Inicial
            </Link>
            
            <Link
              to="/contato"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
              Falar com o Suporte
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcessoNegado;
